import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const expansionPanelDefaultVariants = {
  "size": "lg",
  "padding": true,
  "arrowPosition": "right",
  "position": "bottom"
}
const expansionPanelCompoundVariants = [
  {
    "size": "sm",
    "position": "top",
    "css": {
      "contentWrapper": {
        "p": "16"
      }
    }
  },
  {
    "size": "sm",
    "position": "bottom",
    "css": {
      "contentWrapper": {
        "p": "16"
      }
    }
  },
  {
    "size": "md",
    "position": "top",
    "css": {
      "contentWrapper": {
        "p": "16"
      }
    }
  },
  {
    "size": "md",
    "position": "bottom",
    "css": {
      "contentWrapper": {
        "p": "16"
      }
    }
  },
  {
    "size": "lg",
    "position": "top",
    "css": {
      "contentWrapper": {
        "p": "24"
      }
    }
  },
  {
    "size": "lg",
    "position": "bottom",
    "css": {
      "contentWrapper": {
        "p": "24"
      }
    }
  }
]

const expansionPanelSlotNames = [
  [
    "root",
    "expansionPanel__root"
  ],
  [
    "item",
    "expansionPanel__item"
  ],
  [
    "header",
    "expansionPanel__header"
  ],
  [
    "trigger",
    "expansionPanel__trigger"
  ],
  [
    "icon",
    "expansionPanel__icon"
  ],
  [
    "arrow",
    "expansionPanel__arrow"
  ],
  [
    "title",
    "expansionPanel__title"
  ],
  [
    "content",
    "expansionPanel__content"
  ],
  [
    "contentWrapper",
    "expansionPanel__contentWrapper"
  ]
]
const expansionPanelSlotFns = /* @__PURE__ */ expansionPanelSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, expansionPanelDefaultVariants, getSlotCompoundVariant(expansionPanelCompoundVariants, slotName))])

const expansionPanelFn = memo((props = {}) => {
  return Object.fromEntries(expansionPanelSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const expansionPanelVariantKeys = [
  "position",
  "size",
  "padding",
  "arrowPosition"
]
const getVariantProps = (variants) => ({ ...expansionPanelDefaultVariants, ...compact(variants) })

export const expansionPanel = /* @__PURE__ */ Object.assign(expansionPanelFn, {
  __recipe__: false,
  __name__: 'expansionPanel',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: expansionPanelVariantKeys,
  variantMap: {
  "position": [
    "top",
    "bottom"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "padding": [
    "true",
    "false"
  ],
  "arrowPosition": [
    "left",
    "right"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, expansionPanelVariantKeys)
  },
  getVariantProps
})